import { CommonOutboundAction } from "./actions.ts";
import { IframeBridge } from "@/services/IframeBridge/IframeBridgeService.ts";

type SendOptions = { sendToAllIframes?: boolean };

const SendCommon = {
    tokenRefreshed: (payload: CommonOutboundAction['tokenRefreshed'], options?: SendOptions) => {
        IframeBridge.send<CommonOutboundAction, 'tokenRefreshed'>('tokenRefreshed', payload, options);
    },
    toggleSideBar: (payload: CommonOutboundAction['toggleSideBar'], options?: SendOptions) => {
        IframeBridge.send<CommonOutboundAction, 'toggleSideBar'>('toggleSideBar', payload, options);
    },
    openFilters: (payload: CommonOutboundAction['openFilters'], options?: SendOptions) => {
        IframeBridge.send<CommonOutboundAction, 'openFilters'>('openFilters', payload, options);
    },
    userHeartBeat: (payload: CommonOutboundAction['userHeartBeat'], options?: SendOptions) => {
        IframeBridge.send<CommonOutboundAction, 'userHeartBeat'>('userHeartBeat', payload, options);
    },
};

export default SendCommon;